module.exports = __webpack_public_path__ + "img/App orders Icon - white.74b355fa.svg";